import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

//*Redux
import { useDispatch, useSelector } from 'react-redux';
import action from '../../../Redux Store/actions';

//*MUI
import { Box, Divider, Tooltip } from '@mui/material';

//*files
import Datagrid from '../../../Subcomponents/Datagrid';
import cssClasses from './EventSales.module.css';
import {
  getAllCpForEvents,
  getAllUsersForEvents,
  getEventByEventName,
} from '../../../Services/Event';
import { uniqBy } from 'lodash';
import EventSalesIcon from '../../../Assets/Images/Common/noProjectFound.svg';
import EventCpIcon from '../../../Assets/Images/Common/NoChannelPartnersfound.svg';
import { DataGrid } from '@mui/x-data-grid';

const dataGridStyles = {
  '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
    outline: 'none',
  },
  border: '1px solid #EAECF0 !important',
  fontWeight: '400',
  fontSize: '1.4rem',
  lineHeight: '2rem',
  color: '#667085',
  fontFamily: 'Inter-Medium',
  borderRadius: '8px',
  '& div[data-colindex="1"]': {
    color: '#101828',
    fontWeight: '500',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid #EAECF0',
      background: '#FFFFFF',
      /* Shadow/xl */

      // boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
      borderRadius: '1rem',

      //   "&:nth-of-type(2n+1)": { backgroundColor: "rgba(249, 250, 251, 1)" },
      //   backgroundColor: "#FFFFFF",
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      borderBottom: '1px solid #EAECF0',
      backgroundColor: '#FFFFFF',
      // "&:nth-of-type(2n+1)": {
      //   backgroundColor: "rgba(249, 250, 251, 1)",
      // },
    },
  },
  '& .MuiDataGrid-iconSeparator ': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeader:hover': {
    '& .MuiDataGrid-menuIcon': {
      visibility: 'hidden',
    },
  },

  '&  .MuiDataGrid-columnHeaders': {
    background: '#F9FAFB',
    /* Gray/200 */
    border: '1px solid #EAECF0',
    /* Shadow/xl */
    // boxShadow:
    //   "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
    // borderRadius: "8px",

    marginBottom: '1rem',
    borderBottom: '6px solid #EAECF0',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-checkboxInput': {
    '& svg': {
      width: '2rem',
      height: '2rem',
      background: '#FFFFFF',
    },
  },
  // "& .MuiTablePagination-displayedRows": {
  //   display: "none",
  // },
  '& .MuiDataGrid-footerContainer': {
    '& .MuiTablePagination-displayedRows ': {
      display: 'none',
    },
    '& .MuiDataGrid-selectedRowCount': {
      visibility: 'hidden ',
    },
  },
  "&  [title='Sort']": {
    //visibility:"hidden",
    display: 'none',
    cursor: 'none',
  },
  "& [title='Go to previous page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to next page']": {
    borderRadius: '0',
    border: '1px solid #EAECF0',
    borderRadius: '0.8rem',
    marginRight: '0.5rem',
  },
  "& [title='Go to previous page']:after": {
    content: "'Previous'",
    marginLeft: '1rem',
  },
  "& [title='Go to next page']:before": {
    content: "'Next'",
    marginRight: '1rem',
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 4rem',

    '&:focus': {
      outline: 'none',
    },
  },
  '&  .MuiDataGrid-row ': {
    maxHeight: '72px !important',
    minHeight: '72px !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 4rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiButtonBase-root': {
    fontSize: '1.6rem',
  },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-cell': {
    padding: '0 2rem',
    minHeight: '72px !important',
    maxHeight: '72px !important',
    '&:focus': {
      outline: 'none',
    },
  },
  '& .MuiDataGrid-columnHeader': {
    padding: '0 1rem',

    '&:focus': {
      outline: 'none',
    },
  },
};

function EventSales() {
  const dispatch = useDispatch();
  let loggedInUser = {};

  loggedInUser = useSelector((state) => state.Auth.user);
  console.log(loggedInUser);

  const { eventID } = useParams();
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSalesSize, setPageSalesSize] = useState(12);
  const [pageMaintain, setPageMaintain] = useState(0);
  const [AllUsers, setAllUsers] = useState([]);
  const [NoUsersFound, setNoUsersFound] = useState(null);
  const [EventName, setEventName] = useState('');
  const [TotalCount , setTotalCount] = useState(0);

  useEffect(() => {
    dispatch(action.activeMenu('eventsales'));
    getEventName();
  }, []);

  useEffect(() => {
    console.log('Event-Name', eventID);
    getUsersForEvent(0,false);
  }, [eventID]);

  function getEventName() {
    getEventByEventName(eventID).then((response) => {
      console.log('Event-Name', response[0].title);
      setEventName(response);
    });
  }

  const SalesColumns = [
    {
      field: 'Name',
      headerName: 'Name',
      width: 220,
    },
    {
      field: 'email',
      headerName: 'Email',
      width: 260,
    },
    {
      field: 'MobileNumber',
      headerName: 'Mobile Number',
      width: 200,
    },
  ];

  function getUsersForEvent(pageNumber,merge) {
    getAllUsersForEvents(
      eventID,
      pageNumber * pageSalesSize,
      pageNumber * pageSalesSize + pageSalesSize - 1
    )
      .then((rep) => {
        console.log('Users-data', rep);
        if (rep) {
          let result1 = [];
          rep.data
            .filter((f) => f.LaunchSalesRelations?.length)
            .forEach((element) => {
              element = element.LaunchSalesRelations;
              element.forEach((ele) => {
                let obj3 = flatObject(ele);
                let obj4 = { ...obj3 };
                delete obj4.Users;
                obj4 = { ...obj4, ...obj3.Users };
                result1.push(obj4);
              });
            });
          console.log('users-Result', result1);
         
          let uniqResult1 = uniqBy(result1, 'userId');
          console.log('Users-Final-result', uniqResult1);
          console.log("users-length" , uniqResult1.length)
          setTotalCount(uniqResult1.length)
          if (uniqResult1.length > 0) {
            setNoUsersFound(true);
          } else {
            setNoUsersFound(false);
          }

          const UserData = uniqResult1.map((el, index) => ({
            key: `${el}_${index}`,
            id: el?.userId,
            index: index,
            Name: el?.name,
            email: el?.email,
            MobileNumber: el?.contactNumber,
          }));
          if (merge) {
            setAllUsers((pre) => [...pre, ...UserData]);
          } else {
            setAllUsers([...UserData]);
          }
        }
      })
      .catch((err) => {
        console.error('User-Data', err);
      });
  }


  function getMoreData(passPageNumber) {
    setPageNumber(passPageNumber)
    getUsersForEvent(passPageNumber , true);
  }
  return (
    <Box className={cssClasses.Container}>
      <Box mb={2} padding={'0 2.4rem'}>
        <Box className={cssClasses.HeaderTitle}>{EventName[0]?.title}</Box>
        <Tooltip title={<h1> {EventName[0]?.description}</h1>}>
          <Box
            className={cssClasses.SubTitle}
            width={'70%'}
            overflow={'hidden'}
            textOverflow={'ellipsis'}
            whiteSpace={'nowrap'}
          >
            {EventName[0]?.description}
          </Box>
        </Tooltip>
      </Box>

      <Divider variant='middle' />

      <Box overflow={'auto'} height={'100%'}>
        {NoUsersFound === true && (
          <>
            <Box
              className={cssClasses.FlexRow}
              margin={'2rem 0'}
              padding={'0 2.4rem'}
            >
              <Box className={cssClasses.SubHeaderTitle}>{TotalCount} Sales Managers</Box>
            </Box>

            <Box className={cssClasses.GridWrapper} padding={'0 2.4rem'}>
              {/* <Datagrid
            rows={AllUsers}
            columns={SalesColumns}
            hideFooter={false}
          /> */}

              <DataGrid
                rows={AllUsers}
                columns={SalesColumns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                page={pageMaintain}
                onPageChange={(_page) => {
                  console.log(_page);
                  setPageMaintain(_page);
                  if (pageNumber < _page) {
                    getMoreData(_page);
                    // setPageNumber(_page);
                  }
                }}
                sx={[dataGridStyles]}
              />
            </Box>
          </>
        )}

        {NoUsersFound === false && (
          <Box mt={2}>
            <Box width={'100%'} height={'100%'}>
              <Box className={cssClasses.noDataMsg}>
                <Box className={cssClasses.emptyIcon}>
                  <img src={EventCpIcon} alt='No sales managers were found' />
                </Box>
                <Box className={cssClasses.emptyTitle}>
                  No sales managers were found
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default EventSales;

function flatObject(obj) {
  var newObj = {};
  for (var key in obj) {
    if (typeof obj[key] === 'object') {
      for (var subKey in obj[key]) {
        newObj[subKey] = obj[key][subKey];
      }
    } else {
      newObj[key] = obj[key];
    }
  }
  return newObj;
}
